import { injectable, inject } from "inversify";
import getDecorators from "inversify-inject-decorators";
import container from "../ioc/inversify.config";
import TYPES from "../ioc/types";
import { DefaultSocketIOService } from "./socketio-service";
import { Socket } from "socket.io-client";

export interface EventService {}

const { lazyInject } = getDecorators(container);

@injectable()
export class DefaultEventService implements EventService {
    private iosocket: Socket = null;

    // key = socketio event, value = Phaser event
    private eventMapping = new Map<string, string>();

    private registeredKeys = [];

    private eventsNotToLog = ["save_character_position"];

    constructor(@inject(TYPES.SocketIOService) private socketService: DefaultSocketIOService) {
        this.iosocket = this.socketService.getConnection();
    }

    public emit(action: string, ...params) {
        const filterLog = this.eventsNotToLog.some((event) => event === action);
        if (!filterLog) {
            console.log(
                "*** emitting NETWORK event of type ",
                action,
                ", with args: ",
                params,
                " ***"
            );
        }
        this.iosocket.emit(action, ...params);
    }

    /**
     *
     * The scene parameter came from the plan of using Phaser events as a 'relay' of websocket events.
     * Thus, it needed to be bound to the scene.
     * Before doing that, we're trying to see if simple callbacks wouldn't do the trick more simply
     *
     * @param scene
     * @param event_id
     * @param callback
     */
    public register(event_id: string, callback: Function, scene?: Phaser.Scene) {
        /**
         * Because register is called from abstract-map-scene and is bound to "this.scene",
         * if we do not remove the event listener, the callback continues calling "this.scene".
         * Also, if we just add them, it will trigger multiple times.
         * Possibly there's a miscomprehension of mine about callbacks / scoping, and there would
         * be a better way to deal with the reference to "this.scene" in the callback.
         * Currently, this does the trick.
         */

        if (this.registeredKeys.some((data) => data == event_id)) {
            console.log("ERROR WHEN REGISTERING EVENT: event is already registered", event_id);
        } else {
            this.registeredKeys.push(event_id);
        }
        // Always replace the handler so only one listener exists per event.
        this.iosocket.off(event_id);
        this.iosocket.on(event_id, (args) => {
            console.log(
                "*** received NETWORK event of type ",
                event_id,
                ", with args: ",
                args,
                ", callback: ",
                callback,
                " ***"
            );
            callback(args);
        });
    }

    /**
     * same here, planned a mapping between server events and client events to transform
     * ws events in phaser events and notify the scene
     * @param scene
     * @param event_id
     */
    public emitToObserver(scene: Phaser.Scene, event_id: string) {
        scene.events.emit(this.eventMapping.get(event_id));
    }

    public off(event_id: string) {
        this.iosocket.off(event_id);
    }
}
